import { FINISH_EVO, type Connector } from "../../../../http/lock_calculator/types";

/**
 * Catalog code shown for a connector: the EVO item's when the finish is EVO and the lock has one, otherwise
 * the base lock's (same rule as the backend BOM, definition_bom.go). Single source for the results table,
 * the comparison tab and the 3D legend.
 */
export const connectorCode = (connector: Connector): string | undefined => {
  const lock = connector.lockItem;
  if (connector.finish === FINISH_EVO && lock?.evoItem?.code) return lock.evoItem.code;
  return lock?.item.code;
};
